import { render, staticRenderFns } from "./project.vue?vue&type=template&id=8ead952c&scoped=true"
import script from "./project.vue?vue&type=script&lang=js"
export * from "./project.vue?vue&type=script&lang=js"
import style0 from "./project.vue?vue&type=style&index=0&id=8ead952c&prod&lang=less"
import style1 from "./project.vue?vue&type=style&index=1&id=8ead952c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ead952c",
  null
  
)

export default component.exports